class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMediaId = this.openedBy.getAttribute('data-media-id');

    this.querySelectorAll('[data-media-id]').forEach((media) => {
      media.parentElement.classList.add('hidden');
    });
    this.querySelector(
      `[data-media-id="${activeMediaId}"]`,
    ).parentElement.classList.remove('hidden');
  }
}

customElements.define('product-modal', ProductModal);

// Caching the main elements
var modal_link = $('.button.modal_link');
var overlay = $('.overlay');
var modal = $('.collier-modal');

// Event handler for opening the modal
modal_link.on('click', function(e) {
  modal.addClass('active');
  overlay.addClass('active');
  e.preventDefault();
});

// Event delegation for closing the modal
// This attaches the handler to the document and listens for clicks on .close-icon
$(document).on('click', '.close-icon', function() {
  modal.removeClass('active');
  overlay.removeClass('active');
});